import DisplayConfig from "../../Data/HexMap/DisplayConfig";
import { Note } from "../../Data/HexMap/Note";
import { NoteData } from "../../Data/NoteData";
import { NoteLine } from "./NoteLine";

export function IntervalLines(props:{notes:Note[], displayConfig:DisplayConfig, animate?:boolean, hide?:boolean, clickable?:boolean}){
        const noteLines:JSX.Element[] = []
        if(props.notes.length >= 2){
                noteLines.push(
                        <NoteLine startNote={props.notes[0]} key={0}
                                endNote={props.notes[1]}
                                double={true}
                                hide={props.hide}
                                animate={props.animate}
                                displayConfig={props.displayConfig} />
                )
        }
        if(props.notes.length >= 3){
                noteLines.push(
                        <NoteLine startNote={props.notes[1]} key={1}
                                endNote={props.notes[2]}
                                double={true}
                                hide={props.hide}
                                animate={props.animate}
                                displayConfig={props.displayConfig} />
                )
        }
        if(props.notes.length >= 4){
                noteLines.push(
                        <NoteLine startNote={props.notes[2]} key={2}
                                endNote={props.notes[3]}
                                double={false}
                                hide={props.hide}
                                animate={props.animate}
                                displayConfig={props.displayConfig} />
                )
        }
        if(props.notes.length >= 5){
                noteLines.push(
                        <NoteLine startNote={props.notes[3]} key={3}
                                endNote={props.notes[4]}
                                double={true}
                                hide={props.hide}
                                animate={props.animate}
                                displayConfig={props.displayConfig} />
                )
        }
        if(props.notes.length >= 6){
                noteLines.push(
                        <NoteLine startNote={props.notes[4]} key={4}
                                endNote={props.notes[5]}
                                double={true}
                                hide={props.hide}
                                animate={props.animate}
                                displayConfig={props.displayConfig} />
                )
        }
        if(props.notes.length >= 7){
                noteLines.push(
                        <NoteLine startNote={props.notes[5]} key={5}
                                endNote={props.notes[6]}
                                double={true}
                                hide={props.hide}
                                animate={props.animate}
                                displayConfig={props.displayConfig} />
                )
                noteLines.push(
                        <NoteLine startNote={props.notes[6]} key={6}
                                endNote={props.notes[0]}
                                double={false}
                                hide={props.hide}
                                animate={props.animate}
                                displayConfig={props.displayConfig} />
                )
        }
        return(<g>{noteLines}</g>)
}